import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { fetchTyreSelectionItems } from "../../../redux/actions/globalAction";
import { setCartTypeParameter } from "../../../redux/actions/cartAction";

const TyreBody = ({
  globalData,
  cart,
  fetchTyreSelectionItems,
  setCartTypeParameter,
}) => {
  const [filter, setFilter] = useState(0);
  const [type, setType] = useState(0);

  useEffect(() => {
    // setType(typeTwo)
    fetchTyreSelectionItems();
  }, []);

  const setWidth = (data) => {
    let item = cart.tyreQuotation;
    item.width = data;
    setCartTypeParameter(item);
    setTimeout(function () {
      setFilter(1);
    }, 500);
  };

  const setHeight = (data) => {
    let item = cart.tyreQuotation;
    item.height = data;
    setCartTypeParameter(item);
    setTimeout(function () {
      setFilter(2);
    }, 500);
  };

  const setRim = (data) => {
    let item = cart.tyreQuotation;
    item.rim = data;
    setCartTypeParameter(item);
  };

  const proceed = () => {
    let item = cart.tyreQuotation;
    item.isProceed = true;
    setCartTypeParameter(item);
  }

  let widths = globalData.tyreItems.filter((item) => item.Width !== "");
  let heights = globalData.tyreItems.filter((item) => item.Height !== "");
  let rims = globalData.tyreItems.filter((item) => item.Rim !== "");

  return (
    <>
      <Row className="px-2">
        <Col className="px-4 tyre">
          <h4>
            Service Selected: <span className="text-custom-blue">New Tyre</span>
          </h4>
          <p className="text-black description">
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
            commodo ligula eget dolor. Aenean massa.
          </p>
          {/* <div style={{display:'flex',flexDirection:'row',padding:'10px',alignItems:'center'}}>
                <div style={{fontSize:'20px',fontWeight:'600'}}>Service Selected:</div>
                <div style={{fontSize:'25px',fontWeight:'600',color:'#0451be',marginLeft:'7px'}}> { type==0 ? "New Tyre" : "Battery"}</div>
            </div> */}
          {/* <div style={{display:'flex',flexDirection:'row',padding:'10px',alignItems:'center'}}>
                <div style={{fontSize:'15px',fontWeight:'500'}}></div>
            </div> */}
          <div className="position-relative mb-3">
            <h4 className="mb-2">Select Tyre Size</h4>
            <button className="open-bonnet-btn">
              Let <span className="font-weight-bold">OPEN BONNET</span> Decide
              the Size
            </button>
          </div>

          {/* <div style={{display:'flex',flexDirection:'row',padding:'10px',alignItems:'center'}}>
                <div style={{fontSize:'20px',fontWeight:'600'}}>{type==0 ? "Select Tyre Size" : "Select Size and Details"}</div>
            </div> */}
          <div className="text-center">
            <img src="/assets/repair/tyre.svg" alt="tyre" width="50%" />
          </div>
          {/* <div style={{display:'flex',flexDirection:'row',padding:'10px',alignItems:'center',justifyContent:'center'}}>
                {type==0
                ?
                  <img src="/assets/repair/tyre.svg" />
                  :
                  <img src="/assets/repair/battery.svg" />
                  }
            </div> */}
          <Container>
            <Row className="mt-2">
              <Col
                className={`tab ${filter == 0 ? "active" : ""}`}
                onClick={() => setFilter(0)}
              >
                <p>Width</p>
              </Col>
              <Col
                className={`tab ${filter == 1 ? "active" : ""}`}
                onClick={() => setFilter(1)}
              >
                <p>Height</p>
              </Col>
              <Col
                className={`tab ${filter == 2 ? "active" : ""}`}
                onClick={() => setFilter(2)}
              >
                <p>Rim</p>
              </Col>
            </Row>
          </Container>
          {/* {type==0 && <div style={{zIndex:9}} className="d-flex align-items-center justify-content-center"  >
                <div className="d-flex align-items-center justify-content-evenly" style={{paddingBottom:'10px',paddingTop:'10px'}}>
                  <div style={{fontSize:'13px',width:'10vw',borderBottom:filter==0 ? '3px solid #0451be' :'3px solid #C4C4C4'}} className={`${filter==0 ? "tag-rec-selected" : "tag-rec"}`} onClick={()=>{
                    setFilter(0);
                    }}>Width</div>
                  <div style={{fontSize:'13px',width:'10vw',borderBottom:filter==1 ? '3px solid #0451be' :'3px solid #C4C4C4'}} className={`${filter==1 ? "tag-rec-selected" : "tag-rec"}`} onClick={()=>{
                    setFilter(1);
                  }}>Height</div>
                  <div style={{fontSize:'13px',width:'10vw',borderBottom:filter==2 ? '3px solid #0451be' :'3px solid #C4C4C4'}} className={`${filter==2 ? "tag-rec-selected" : "tag-rec"}`} onClick={()=>{
                    setFilter(2);
                  }}>Rim</div>
                </div>
            </div>} */}
          <Container className="text-center">
            {/* {type==0 ?<Col lg={12} style={{paddingLeft:'35px',paddingRight:'35px'}}> */}
            {filter == 0 ? (
              <Row>
                {widths.map((e, index) => (
                  <Col lg={2} className="mt-2">
                    <a
                      style={{
                        padding: "5px 10px",
                        background:
                          cart.tyreQuotation.width == e.Width
                            ? "#0451be"
                            : "#F3F3F3",
                        color:
                          cart.tyreQuotation.width == e.Width ? "#fff" : "#000",
                      }}
                      onClick={() => setWidth(e.Width)}
                    >
                      {e.Width}
                    </a>
                  </Col>
                ))}
              </Row>
            ) : filter == 1 ? (
              <Row>
                {heights.map((e, index) => (
                  <Col lg={2} className="mt-2">
                    <a
                      style={{
                        padding: "5px 10px",
                        background:
                          cart.tyreQuotation.height == e.Height
                            ? "#0451be"
                            : "#F3F3F3",
                        color:
                          cart.tyreQuotation.height == e.Height ? "#fff" : "#000",
                      }}
                      onClick={() => setHeight(e.Height)}
                    >
                      {e.Height}
                    </a>
                  </Col>
                ))}
              </Row>
            ) : (
              <Row>
                {rims.map((e, index) => (
                  <Col lg={2} className="mt-2">
                    <a
                      style={{
                        padding: "5px 10px",
                        background:
                          cart.tyreQuotation.rim == e.Rim
                            ? "#0451be"
                            : "#F3F3F3",
                        color:
                          cart.tyreQuotation.rim == e.Rim ? "#fff" : "#000",
                      }}
                      onClick={() => setRim(e.Rim)}
                    >
                      {e.Rim}
                    </a>
                  </Col>
                ))}
              </Row>
            )}
          </Container>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "end",
              paddingBottom: "70px",
              paddingRight: "30px",
            }}
          >
            <button className="otp-button" style={{ background: "#F58B1F" }} onClick={proceed}>
              Proceed
            </button>
          </div>
        </Col>
      </Row>
      {/* <div className='workshop-bottom-button' onClick={()=>{console.log(globalData)}}>
        <div className='workshop-select'>{"LET "}</div>
        <div className='workshop-select-ob'>{" OPEN BONNET "}</div>
        <div className='workshop-select'>{" SELECT MY GARAGE"}</div>
      </div> */}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchTyreSelectionItems: () => {
      dispatch(fetchTyreSelectionItems());
    },
    setCartTypeParameter: (data) => {
      dispatch(setCartTypeParameter(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TyreBody);

// fetchTyreSelectionItems
// export default ;
